// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"571":"b88f002f","790":"5b91b453"}[chunkId] + ".chunk.js";
};